import React from 'react';
import './PageStyles.css';

export default function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="page-hero hero-gradient">
        <div className="container text-center">
          <span className="section-label" style={{ background: 'rgba(103,183,247,0.15)', color: 'var(--secondary)' }}>Legal</span>
          <h1>Privacy Policy</h1>
          <p>Last updated: January 1, 2025</p>
        </div>
      </div>
      <section>
        <div className="container">
          <div className="legal-content">
            <h2>1. Information We Collect</h2>
            <p>We collect information you provide directly to us, including:</p>
            <ul>
              <li>Name, email address, and phone number when you register</li>
              <li>Payment information when you subscribe to a plan</li>
              <li>Transaction and points data generated through platform use</li>
              <li>Device information and usage analytics</li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <p>We use collected information to:</p>
            <ul>
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Send promotional communications (with your consent)</li>
              <li>Monitor and analyze usage patterns to improve user experience</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2>3. Information Sharing</h2>
            <p>We do not sell your personal information. We may share information with:</p>
            <ul>
              <li>Store owners when you interact with their loyalty programs</li>
              <li>Service providers who assist in operating our platform</li>
              <li>Legal authorities when required by law</li>
            </ul>

            <h2>4. Data Security</h2>
            <p>We implement industry-standard security measures including encryption, secure servers, and access controls to protect your personal information. However, no method of transmission over the internet is 100% secure.</p>

            <h2>5. Cookies</h2>
            <p>We use cookies and similar technologies to enhance your experience, analyze traffic, and personalize content. You can control cookie settings through your browser preferences.</p>

            <h2>6. Data Retention</h2>
            <p>We retain your data for as long as your account is active or as needed to provide services. You may request deletion of your data by contacting us at privacy@pointfinity.com.</p>

            <h2>7. Your Rights</h2>
            <p>You have the right to access, correct, or delete your personal data. To exercise these rights, contact us at privacy@pointfinity.com.</p>

            <h2>8. Children's Privacy</h2>
            <p>Our services are not directed to children under 13. We do not knowingly collect personal information from children under 13.</p>

            <h2>9. Changes to This Policy</h2>
            <p>We may update this Privacy Policy periodically. We will notify you of significant changes via email or platform notification.</p>

            <h2>10. Contact Us</h2>
            <p>For privacy-related inquiries, contact us at privacy@pointfinity.com.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
